import * as API from '@/services/API';

export default {
  get(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/namelists/${options.id}${query}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/namelists/${query}`);
  },
  async bulk(data) {
    return API.apiClient.post(`/namelists/bulk`, data);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/namelists`, data);
    } else {
      return API.apiClient.put(`/namelists/${id}`, data);
    }
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async delete(id) {
    return API.apiClient.delete(`/namelists/${id}`);
  }
};
